/*
 * FLIQA — SKU bazlı MOQ (min. sipariş adedi) + ardışık artış sistemi.
 *
 * Veri kaynağı: sections/moq-manager.liquid (layout/theme.liquid içinde
 * global render edilir) -> #fliqa-moq-rules JSON script.
 *
 * Kural yoksa hiçbir şeye dokunmaz — temanın varsayılan quantity-input
 * davranışı (1,2,3,4...) aynen çalışır.
 *
 * Etki alanı: ürün sayfası quantity selector + varyant değişimi,
 * sepet sayfası (cart-template.liquid) satır quantity'leri, sepete ekleme
 * doğrulaması. Sepet çekmecesinde (ajax-cart) miktar artırma/azaltma
 * kontrolü yok (sadece "Kaldır"), o yüzden orada ek bir şey gerekmiyor.
 */
(function () {
  'use strict';

  function readRules() {
    var el = document.getElementById('fliqa-moq-rules');
    if (!el) return {};
    try {
      var data = JSON.parse(el.textContent);
      return data && typeof data === 'object' ? data : {};
    } catch (err) {
      console.warn('FLIQA MOQ: kural verisi okunamadı.', err);
      return {};
    }
  }

  var RULES = readRules();

  function ruleFor(sku) {
    if (!sku) return null;
    var r = RULES[String(sku).trim()];
    if (!r) return null;
    var moq = parseInt(r.moq, 10);
    var step = parseInt(r.step, 10);
    if (!(moq > 0)) moq = 1;
    if (!(step > 0)) step = 1;
    return { moq: moq, step: step };
  }

  /* SKU'ya karşılık gelen varyant nesnesi (stok kontrolü için). */
  function variantForSku(sku) {
    if (!sku || !window.theme || !theme.product || !theme.product.variants) return null;
    var list = theme.product.variants;
    for (var i = 0; i < list.length; i++) {
      if (list[i].sku != null && String(list[i].sku).trim() === String(sku).trim()) return list[i];
    }
    return null;
  }

  /* Geçerli MOQ kuralı: JSON'daki kural + STOK KONTROLÜ.
     Varyantın stoğu MOQ'nun altına düştüyse (stok takibi açık ve stok > 0),
     MOQ kuralı KALDIRILIR — müşteri stokta kalanı tekli alabilsin.
     Dönüş:
       null                         → JSON'da kural yok
       { relaxed:true, cap:N }      → kural var ama stok < MOQ, gevşetildi (N = stok)
       { moq, step }                → normal MOQ kuralı geçerli */
  function stockAwareRule(sku) {
    var rule = ruleFor(sku);
    if (!rule) return null;
    var v = variantForSku(sku);
    if (v && v.inventory_management && typeof v.inventory_quantity === 'number') {
      if (v.inventory_quantity > 0 && v.inventory_quantity < rule.moq) {
        return { relaxed: true, cap: v.inventory_quantity };
      }
    }
    return { moq: rule.moq, step: rule.step };
  }

  function skuHostOf(qtyEl) {
    return qtyEl.closest('[data-sku]');
  }

  function ruleOf(qtyEl) {
    var moq = parseInt(qtyEl.getAttribute('data-fliqa-moq') || '0', 10);
    var step = parseInt(qtyEl.getAttribute('data-fliqa-step') || '0', 10);
    if (!(moq > 0) && !(step > 0)) return null;
    return { moq: moq > 0 ? moq : 1, step: step > 0 ? step : 1 };
  }

  function snapToStep(raw, moq, step) {
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < moq) return moq;
    var over = n - moq;
    var snapped = moq + Math.round(over / step) * step;
    return snapped < moq ? moq : snapped;
  }

  function showNote(qtyEl, text) {
    var host = skuHostOf(qtyEl);
    var note = host && host.querySelector('[data-fliqa-note]');
    if (!note) return;
    note.textContent = text;
    note.hidden = false;
    clearTimeout(note._fliqaTimer);
    note._fliqaTimer = setTimeout(function () {
      note.hidden = true;
    }, 4500);
  }

  /* NOT: "Birim fiyat / Toplam" kutusu ve MOQ tabanlı hızlı miktar kartları
     kaldırıldı. Kutunun bulunduğu alan artık "Sepetinizde bu üründen bulunan
     varyantlar" listesini gösteriyor (bkz. product-snippet.liquid
     'moq-pricing' + orada inline script). Bu dosya sadece MOQ stepper
     davranışını (min/adım/doğrulama) yönetiyor. */

  function applyRule(qtyEl, reset) {
    var input = qtyEl.querySelector("input[name='quantity']");
    if (!input) return;
    var host = skuHostOf(qtyEl);
    var sku = host ? host.getAttribute('data-sku') : null;
    var rule = stockAwareRule(sku);

    /* Kural yok VEYA stok MOQ'nun altında (gevşetildi):
       MOQ kancalarını kaldır — müşteri stoktakini tekli/serbest alsın. */
    if (!rule || rule.relaxed) {
      qtyEl.removeAttribute('data-fliqa-moq');
      qtyEl.removeAttribute('data-fliqa-step');
      input.min = 1;
      if (rule && rule.relaxed && rule.cap > 0) {
        input.max = rule.cap;
        var cur = parseInt(input.value, 10);
        if (reset || isNaN(cur) || cur < 1) {
          input.value = 1;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        } else if (cur > rule.cap) {
          input.value = rule.cap;
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      return;
    }

    qtyEl.setAttribute('data-fliqa-moq', rule.moq);
    qtyEl.setAttribute('data-fliqa-step', rule.step);
    input.min = rule.moq;
    input.removeAttribute('max');
    if (input.hasAttribute('readonly')) input.removeAttribute('readonly');

    var current = parseInt(input.value, 10);
    if (reset || isNaN(current) || current < rule.moq) {
      input.value = rule.moq;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function initAll() {
    var list = document.querySelectorAll('quantity-input');
    for (var i = 0; i < list.length; i++) applyRule(list[i], false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* +/- düzeltmesi: tema kendi ±1 mantığını (common.js) "click" anında,
     doğrudan hedef elemana bağlı bir dinleyiciyle uyguluyor ve input.value'yu
     TIKLAMA OLAYI İÇİNDE değiştiriyor — yani "click" bize ulaştığında değer
     zaten (yanlış şekilde) ±1 değişmiş oluyor. Bu yüzden gerçek "tıklama
     öncesi" değeri "click"ten daha ERKEN ateşlenen "pointerdown"da
     yakalıyoruz (pointerdown → mouseup → click sırası tarayıcıda sabittir),
     sonra "click"te temanın yaptığı değişikliği yok sayıp kendi adımımızı
     bu temiz değerin üzerine uyguluyoruz — tema kodu hiç değişmiyor. */
  var fliqaPreClickQty = null;
  function snapshotPreClick(e) {
    var minus = e.target.closest('quantity-input-minus');
    var plus = e.target.closest('quantity-input-plus');
    if (!minus && !plus) {
      fliqaPreClickQty = null;
      return;
    }
    var qtyEl = (minus || plus).closest('quantity-input');
    var rule = qtyEl && ruleOf(qtyEl);
    if (!rule) {
      fliqaPreClickQty = null;
      return;
    }
    var input = qtyEl.querySelector("input[name='quantity']");
    fliqaPreClickQty = input ? parseInt(input.value, 10) : null;
  }
  document.addEventListener('pointerdown', snapshotPreClick);
  document.addEventListener('mousedown', snapshotPreClick);

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('quantity-input-minus');
    var plus = e.target.closest('quantity-input-plus');
    if (!minus && !plus) return;
    var qtyEl = (minus || plus).closest('quantity-input');
    if (!qtyEl) return;
    var rule = ruleOf(qtyEl);
    if (!rule) return;
    var input = qtyEl.querySelector("input[name='quantity']");
    if (!input) return;
    var base = fliqaPreClickQty;
    if (base === null || isNaN(base)) base = rule.moq;
    var next = minus ? base - rule.step : base + rule.step;
    if (next < rule.moq) next = rule.moq;
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    fliqaPreClickQty = null;
  });

  /* Manuel miktar girişi doğrulama (readonly, sadece kural varken kaldırılır). */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches("input[name='quantity']")) return;
    var qtyEl = input.closest('quantity-input');
    if (!qtyEl) return;
    var rule = ruleOf(qtyEl);
    if (!rule) return;
    var snapped = snapToStep(input.value, rule.moq, rule.step);
    if (String(snapped) !== String(input.value)) {
      input.value = snapped;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      showNote(
        qtyEl,
        'Bu ürün minimum ' + rule.moq + ' adet sipariş edilebilir ve ' + rule.step + '’er adet artırılabilir. Miktar ' + snapped + '’e ayarlandı.'
      );
    }
  });

  /* "Min. Sipariş Miktarı: X adet/çift" satırı — SKU değişince (varyant
     değişimi) güncellenir. Kural yoksa veya stok MOQ'nun altındaysa 1.
     Birim, elementteki data-moq-unit özniteliğinden gelir (Liquid'de
     settings.moq_pair_tags'e göre "çift" ya da "adet"). */
  function updateMoqLine(sku) {
    var els = document.querySelectorAll('[data-prd-moq-value]');
    if (!els.length) return;
    var rule = stockAwareRule(sku);
    var moq = (rule && !rule.relaxed) ? rule.moq : 1;
    for (var i = 0; i < els.length; i++) {
      var unit = els[i].getAttribute('data-moq-unit') || 'adet';
      els[i].textContent = moq + ' ' + unit;
    }
  }

  /* Varyant değişimi: #select-master (gizli varyant id alanı) her
     değiştiğinde yeni varyantın SKU'sunu bul ve quantity-input'u sıfırla. */
  var lastVariantId = null;
  function checkVariantChange() {
    var sel = document.getElementById('select-master');
    if (!sel) return;
    if (sel.value === lastVariantId) return;
    lastVariantId = sel.value;
    if (!window.theme || !theme.product || !theme.product.variants) return;
    var variant = null;
    for (var i = 0; i < theme.product.variants.length; i++) {
      if (String(theme.product.variants[i].id) === String(sel.value)) {
        variant = theme.product.variants[i];
        break;
      }
    }
    if (!variant) return;
    updateMoqLine(variant.sku);
    var host = document.querySelector('.js-product-quantity');
    if (!host) return;
    host.setAttribute('data-sku', variant.sku || '');
    var qtyEl = host.querySelector('quantity-input');
    if (qtyEl) applyRule(qtyEl, true);
  }
  document.addEventListener('click', checkVariantChange);
  document.addEventListener('change', checkVariantChange);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkVariantChange);
  } else {
    checkVariantChange();
  }

  /* Sepete ekleme doğrulaması — capture: true ile temanın kendi AJAX
     submit işlemesinden ÖNCE çalışır, geçersizse gönderimi durdurur. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.js-form-add-to-cart')) return;
      var qtyEl = form.querySelector('quantity-input');
      if (!qtyEl) return;
      var rule = ruleOf(qtyEl);
      if (!rule) return;
      var input = qtyEl.querySelector("input[name='quantity']");
      if (!input) return;
      var val = parseInt(input.value, 10);
      var snapped = snapToStep(val, rule.moq, rule.step);
      if (snapped !== val) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.value = snapped;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        showNote(
          qtyEl,
          'Bu ürün minimum ' + rule.moq + ' adet sipariş edilebilir ve ' + rule.step + '’er adet artırılabilir.'
        );
      }
    },
    true
  );
})();
